import { render, staticRenderFns } from "./金融服务.vue?vue&type=template&id=6bbea198&scoped=true"
import script from "./金融服务.vue?vue&type=script&lang=js"
export * from "./金融服务.vue?vue&type=script&lang=js"
import style0 from "./金融服务.vue?vue&type=style&index=0&id=6bbea198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbea198",
  null
  
)

export default component.exports